"use client";

import Link from "next/link";

import {
  legalDocuments,
  type LegalDocumentSlug,
} from "@/config/legal/legal-documents";
import { cn } from "@/lib/utils";

interface LegalDocsNavProps {
  currentSlug: string;
}

export default function LegalDocsNav({ currentSlug }: LegalDocsNavProps) {
  const docs = Object.entries(legalDocuments) as [
    LegalDocumentSlug,
    (typeof legalDocuments)[LegalDocumentSlug],
  ][];

  return (
    <nav className="space-y-1 lg:sticky lg:top-24 lg:self-start">
      {docs.map(([slug, doc]) => (
        <Link
          key={slug}
          href={`/legal/${slug}`}
          className={cn(
            "block text-sm transition-colors",
            currentSlug === slug
              ? "text-foreground font-medium"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {doc.title}
        </Link>
      ))}
    </nav>
  );
}
